import { useMutation } from '@tanstack/react-query'
import type { ProcessesApiSetStoreAddressRequest } from '@itsrever/rever-api'
import { processesApi } from '@/api/processes-api'

const setStore = async (req: ProcessesApiSetStoreAddressRequest) => {
  const data = await processesApi.setStoreAddress(req)
  return data
}

export const useSetStoreAddress = () => {
  return useMutation({
    mutationFn: setStore
  })
}
